const BankDetailField = ({ label, labelClassName='', value, valueClassName='' }) => {
  return (
    <div className="md:tw-space-y-2">
      <div className={`tw-font-semibold tw-text-sm tw-opacity-40 ${labelClassName}`}>{label}</div>
      <div className={`tw-text-base ${valueClassName}`}>
        {' '}
        {value === undefined || value === null ? 'N/A' : value == 0 ? 0 : value}
      </div>
    </div>
  );
};

export default BankDetailField;
